export default "/static/build/https.png";